import { render, staticRenderFns } from "./blackFridayComponent.vue?vue&type=template&id=3082daec&scoped=true"
import script from "./blackFridayComponent.vue?vue&type=script&lang=js"
export * from "./blackFridayComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3082daec",
  null
  
)

export default component.exports